/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type FeeBeneficiaryInput = { wallet: Address; shareBps: number };

export type FeeBeneficiaryInputArgs = FeeBeneficiaryInput;

export function getFeeBeneficiaryInputEncoder(): FixedSizeEncoder<FeeBeneficiaryInputArgs> {
  return getStructEncoder([
    ['wallet', getAddressEncoder()],
    ['shareBps', getU16Encoder()],
  ]);
}

export function getFeeBeneficiaryInputDecoder(): FixedSizeDecoder<FeeBeneficiaryInput> {
  return getStructDecoder([
    ['wallet', getAddressDecoder()],
    ['shareBps', getU16Decoder()],
  ]);
}

export function getFeeBeneficiaryInputCodec(): FixedSizeCodec<
  FeeBeneficiaryInputArgs,
  FeeBeneficiaryInput
> {
  return combineCodec(
    getFeeBeneficiaryInputEncoder(),
    getFeeBeneficiaryInputDecoder(),
  );
}
